import {tilerootpath} from "../../../api_servcies/apirootpath"
import { bgColors } from "../../../utils/bgColor"
const userprojecturl = `${tilerootpath}/Userproject`
export function Userproject(map){
  const source_id = "Userproject"
  const layer_id =  "Userproject"
  let visibility = 'visible'
//   if(WaterBodies===false){
//     visibility = 'none'
//   }
  if (map) {
  if (map.getLayer(layer_id)) {
    map.removeLayer(layer_id);
  }
  if (map.getSource(source_id)) {
     map.removeSource(source_id);
  }
    map.addSource(`${source_id}`, {
    type: 'vector',
    "tiles": [`${userprojecturl}/{z}/{x}/{y}.mvt`],
    "tolerance": 1,
    'minzoom': 7
    // 'maxzoom': 20,
  });
  map.addLayer({
    'id': `${source_id}`,
    'source': `${layer_id}`,
     'source-layer': `${layer_id}`,
    "type": "fill",
    'layout': {
      'visibility': visibility,
    },
    'paint': {
        'fill-outline-color':bgColors.grey_300,
        'fill-color': 'transparent',
        }
  });
  map.addLayer(
    {
      'id': 'Userproject_highlighted',
      // 'type': 'fill',
      'type': 'line',
      'source': `${source_id}`,
      'source-layer': `${layer_id}`,
      'minzoom': 7,
      'paint': {
        'line-color': bgColors.green_300,
        'line-width': 2
        // 'fill-outline-color': bgColors.green_500,
        // 'fill-color': bgColors.grey_500,
        // 'fill-opacity': 0.3
      },
      'filter': ['in', 'id', '']
      },
    // // Place polygons under labels.
    // 'india_village-label'
  );
//   map.on('click', (e) => {
//     // Change the cursor style as a UI indicator.
//             const bbox = [
//                 [e.point.x - 5, e.point.y - 5],
//                 [e.point.x + 5, e.point.y + 5]
//                 ];
            
//             const selectedFeatures = map.queryRenderedFeatures(bbox, {
//               layers: ['Userproject']
//             });
//             // console.log(selectedFeatures)
//           if (selectedFeatures !== undefined && selectedFeatures.length > 0 ) {
//               map.setFilter('Userproject_highlighted', [
//               'in',
//               'feature_id',
//             selectedFeatures[0].properties.feature_id
//               ]);
//             }
            
//             });


}
}

export function handleUserprojectlayer(map,WaterBodies){
  const source_id = "Userproject"
  const layer_id =  "Userproject"
//   const layer_id_highlighted =  "Userproject_highlighted"


  if(Userproject===false){
    if (map.getLayer(layer_id)) {
        // map.removeLayer(layer_id_highlighted)
        map.removeLayer(layer_id);
        // map.removeLayer(layer_id_highlighted);
      }
    if (map.getSource(source_id)) {
         map.removeSource(source_id);
      }
  }
}
